import { Paginated } from '../types';
import { Hardware } from '../types/hardware.type';
import { ApiRepository } from './main repository/api.repository';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace HardwareService {
  const BASE_API = `${window.globalConfiguration.api.data}/v1/hardware`;

  export const get = async ({
    page,
    limit,
    filter,
  }: {
    page: number;
    limit: number;
    filter?: string;
  }): Promise<Paginated<Hardware>> => {
    return ApiRepository.Core().get<Paginated<Hardware>>(`${BASE_API}/paginated`, {
      page,
      limit,
      filter,
    });
  };
}
